import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "upload-header"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "https://kinyun.oss-cn-beijing.aliyuncs.com/tool/坐席导入模版.xlsx",
  download: "坐席导入模版"
}, "下载模版", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 确定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: true,
    width: "600px",
    title: `${_ctx.modalState[_ctx.type]}坐席表`,
    afterClose: _ctx.afterClose,
    onCancel: _ctx.afterClose,
    maskClosable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.afterClose
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"]),
      (!_ctx.isView)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "submit",
            type: "primary",
            loading: _ctx.loading,
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!_ctx.isView)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_a_upload, {
              accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "show-upload-list": false,
              action: "/call/seat/import.np",
              onChange: _ctx.customUploadRequest
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onChange"]),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_a_table, {
        scroll: _ctx.scroll,
        "data-source": _ctx.data,
        columns: _ctx.columns,
        loading: _ctx.loading,
        pagination: _ctx.showPage ? _ctx.pagination : false,
        ref: "tableElRef",
        onChange: _ctx.handleTableChange,
        "row-key": (record) => record.seat
      }, null, 8, ["scroll", "data-source", "columns", "loading", "pagination", "onChange", "row-key"])
    ]),
    _: 1
  }, 8, ["title", "afterClose", "onCancel"]))
}